import React from 'react'
import MessageUI from '../output/MessageUI'
import './Card.css'

const CardUI = ({context, className, icon, messageList, titleMessageKey, title, children, noUnderline}) =>
  <div className={`w_card ${className ? className : ''}`}>
    {
      (titleMessageKey || title) &&
      <header className={`g_row ${noUnderline ? '' : 'under_line'}`}>
        {
          icon &&
          <div className={`icon ${icon} g_col`}></div>
        }
        <span className='title g_col g_h3'>
          {
            titleMessageKey &&
            <MessageUI messageList={messageList} messageKey={titleMessageKey} />
          }
          {
            title &&
            <span>{title}</span>
          }
        </span>
      </header>
    }
    {children}
  </div>

export default CardUI
